import { __rest } from "tslib";
import classNames from 'classnames';
import React from 'react';
var css = {
  "newButtonGroupItem": "rui-pdy8W",
  "disabled": "rui-Y3FxV",
  "selected": "rui-teFcP"
};
var NewButtonGroupItem = function NewButtonGroupItem(_a) {
  var _a$disabled = _a.disabled,
    disabled = _a$disabled === void 0 ? false : _a$disabled,
    onClick = _a.onClick,
    _a$selected = _a.selected,
    selected = _a$selected === void 0 ? false : _a$selected,
    text = _a.text,
    children = _a.children,
    rest = __rest(_a, ["disabled", "onClick", "selected", "text", "children"]);
  return /*#__PURE__*/React.createElement("button", Object.assign({
    className: classNames(css.newButtonGroupItem, disabled ? css.disabled : null, selected ? css.selected : null),
    onClick: onClick
  }, rest), text, children);
};
NewButtonGroupItem.defaultProps = {
  disabled: false,
  selected: false
};
export default NewButtonGroupItem;